import Drawer from '@mui/material/Drawer';
import { FC, memo } from 'react';

import DrawerContentWrapper from './components/DrawerContentWrapper';
import { SelectUsersProps } from './types';

const SelectUsers: FC<SelectUsersProps> = memo((props) => {
  const { isOpened, onClose } = props;

  return (
    <Drawer open={isOpened} onClose={onClose} anchor="right" PaperProps={{ sx: { width: 1, maxWidth: 480 } }}>
      {isOpened && <DrawerContentWrapper props={props} />}
    </Drawer>
  );
});

export default SelectUsers;
